import { UmaError } from '@orbis-systems/orbis-api-clients/uma';

export const isUmaErrorArray = (obj: unknown): obj is UmaError[] => {
    return (
        Array.isArray(obj) &&
        obj.every((item) => {
            if (typeof item !== 'object' || item === null) {
                return false;
            }

            const errorItem = item as Record<string, unknown>;

            return (
                (errorItem.available_options === undefined ||
                    (Array.isArray(errorItem.available_options) &&
                        errorItem.available_options.every((opt) => typeof opt === 'string'))) &&
                (errorItem.code === undefined || typeof errorItem.code === 'number') &&
                (errorItem.description === undefined || typeof errorItem.description === 'string') &&
                (errorItem.field === undefined || typeof errorItem.field === 'string') &&
                (errorItem.request_id === undefined || typeof errorItem.request_id === 'string')
            );
        })
    );
};
